export const reviews = [
  {
    id: 1,
    username: '漫迷小陈',
    handle: '@xiaochen_manga',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20anime%20style%20avatar%2C%20stylish%20haircut%2C%20warm%20expression%2C%20simple%20light%20gray%20background%2C%20clean%20digital%20portrait%2C%20professional%20illustration&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '"全球诡异时代真的是今年最惊艳的悬疑漫画！画风细腻，剧情环环相扣，每一话结尾都让我迫不及待想看下一话。林夜的觉醒过程太燃了！"',
    comicTitle: '全球诡异时代',
    rating: 5,
    date: '2026-07-07',
  },
  {
    id: 2,
    username: '深夜追漫人',
    handle: '@night_reader',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20anime%20style%20avatar%2C%20long%20dark%20hair%2C%20glasses%2C%20gentle%20smile%2C%20simple%20light%20gray%20background%2C%20clean%20digital%20portrait%2C%20professional%20illustration&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '"一口气看到凌晨三点，根本停不下来！诡异世界观的设定非常新颖，每个角色都有血有肉。墨渊老师的画功也超赞！"',
    comicTitle: '全球诡异时代',
    rating: 5,
    date: '2026-07-06',
  },
  {
    id: 3,
    username: '热血少年',
    handle: '@hotblood_boy',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%2C%20spiky%20hair%2C%20energetic%20expression%2C%20sports%20headband%2C%20simple%20light%20gray%20background%2C%20clean%20digital%20portrait%2C%20professional%20illustration&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '"斗罗之武魂觉醒的特效和战斗场面太震撼了！双生武魂的设定直接拉满，唐辰太帅了！每周都在等更新。"',
    comicTitle: '斗罗之武魂觉醒',
    rating: 5,
    date: '2026-07-07',
  },
  {
    id: 4,
    username: '二次元观察员',
    handle: '@anime_observer',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20avatar%20of%20young%20person%20with%20headphones%2C%20casual%20style%2C%20thoughtful%20expression%2C%20simple%20light%20gray%20background%2C%20clean%20digital%20portrait%2C%20professional%20illustration&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '"星际流浪者的世界观极其宏大，3026年的银河系设定非常有想象力。每个星球的文明设计都令人惊叹，星河老师太有才了。"',
    comicTitle: '星际流浪者',
    rating: 4,
    date: '2026-07-05',
  },
  {
    id: 5,
    username: '恐怖控',
    handle: '@horror_fan',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20gothic%20girl%20avatar%2C%20dark%20makeup%2C%20mysterious%20expression%2C%20simple%20light%20gray%20background%2C%20clean%20digital%20portrait%2C%20professional%20illustration&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '"午夜理发店这个题材太绝了！看似普通的故事下藏着深深的恐怖。夜不语老师一如既往地擅长营造心理恐惧感。"',
    comicTitle: '午夜理发店',
    rating: 4,
    date: '2026-07-04',
  },
  {
    id: 6,
    username: '漫画老司机',
    handle: '@manga_veteran',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20middle%20aged%20man%20avatar%2C%20beard%2C%20wise%20expression%2C%20simple%20light%20gray%20background%2C%20clean%20digital%20portrait%2C%20professional%20illustration&width=120&height=120&seq=avatar-06&orientation=squarish',
    content: '"追了十几年漫画，全球诡异时代是我近五年来看到的最有诚意的国产悬疑作品。画面质感、分镜节奏都达到了国际水准。"',
    comicTitle: '全球诡异时代',
    rating: 5,
    date: '2026-07-03',
  },
  {
    id: 7,
    username: '修仙道友',
    handle: '@xiuxian_daoyou',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20Chinese%20swordsman%20avatar%2C%20traditional%20robe%2C%20calm%20expression%2C%20simple%20light%20gray%20background%2C%20clean%20digital%20portrait%2C%20professional%20illustration&width=120&height=120&seq=avatar-07&orientation=squarish',
    content: '"剑仙在此的画风太美了！云中子的国风水墨风格配合传统仙侠元素，每一格都像艺术品一样精致！"',
    comicTitle: '剑仙在此',
    rating: 5,
    date: '2026-07-06',
  },
  {
    id: 8,
    username: '推理达人',
    handle: '@deduction_master',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20detective%20avatar%2C%20trench%20coat%2C%20sharp%20eyes%2C%20simple%20light%20gray%20background%2C%20clean%20digital%20portrait%2C%20professional%20illustration&width=120&height=120&seq=avatar-08&orientation=squarish',
    content: '"灵异事件调查局每个案件都设计得非常精妙，反转超多，根本猜不到结局！喜欢推理和悬疑的朋友一定不能错过。"',
    comicTitle: '灵异事件调查局',
    rating: 4,
    date: '2026-07-05',
  },
];